import Container from './Container'
export default Container


// WEBPACK FOOTER //
// ./src/pages/Login/LoginContinue/index.js